import { useEffect, useState } from "react";

/**
 * Returns a copy of `value` that only updates after `delayMs` have passed
 * without further changes. Useful for debouncing input that drives expensive
 * side effects (search queries, network calls) so they don't fire on every
 * keystroke.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(handle);
  }, [value, delayMs]);

  return debounced;
}
